export const navigations = [
	{ name: 'Why Reimbucks?', to: 'why-reimbucks' },
	{ name: 'Product', to: 'product' },
	{ name: 'Pricing', to: 'pricing' },
];
